import { api } from "../api/Middleware";
import {
  SUPPORT_CONFIG_LIST_URL,
  SUPPORT_CONFIG_CREATE_URL,
  SUPPORT_CONFIG_UPDATE_URL,
  SUPPORT_TICKETS_LIST_URL,
  SUPPORT_TICKETS_CREATE_URL,
  SUPPORT_TICKETS_UPDATE_URL,
  SUPPORT_TICKETS_ASSIGN_URL,
  SUPPORT_CHATS_LIST_URL,
  SUPPORT_CHATS_CREATE_URL,
  SUPPORT_CHATS_ASSIGN_URL,
  SUPPORT_CHATS_CLOSE_URL,
  SUPPORT_CHATS_MESSAGES_URL,
  SUPPORT_AGENTS_LIST_URL,
  SUPPORT_AGENTS_CREATE_URL,
  SUPPORT_AGENTS_UPDATE_URL,
  SUPPORT_AGENTS_UPDATE_STATUS_URL,
  SUPPORT_AGENTS_AVAILABLE_URL,
  WEBSOCKET_URL,
} from "../api/Urls";

const SupportService = {
  // ===============================================
  // CONFIGURA��O DE SUPORTE
  // ===============================================

  getSupportConfig: async () => {
    try {
      const response = await api.get(SUPPORT_CONFIG_LIST_URL);
      
      // Verificar se a resposta tem formato paginado
      if (response.data && typeof response.data === 'object' && 'results' in response.data) {
        // API retorna formato paginado: { count, next, previous, results }
        const configs = response.data.results;
        
        if (configs && configs.length > 0) {
          // Retornar a primeira configuração encontrada
          return {
            success: true,
            data: configs[0],
          };
        } else {
          // Array results está vazio - não há configuração ainda
          return {
            success: true,
            data: null,
          };
        }
      } else {
        // API retorna objeto único diretamente
        return {
          success: true,
          data: response.data,
        };
      }
    } catch (error) {
      if (error.response?.status === 404) {
        return {
          success: true,
          data: null,
        };
      }
      
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte não está disponível",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao buscar configuração do suporte",
      };
    }
  },

  createSupportConfig: async (configData) => {
    try {
      const response = await api.post(SUPPORT_CONFIG_CREATE_URL, configData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao criar configura��o do suporte",
      };
    }
  },

  updateSupportConfig: async (configId, configData) => {
    try {
      const response = await api.put(SUPPORT_CONFIG_UPDATE_URL(configId), configData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao atualizar configura��o do suporte",
      };
    }
  },

  // ===============================================
  // SISTEMA DE TICKETS
  // ===============================================

  getTickets: async (filters = {}) => {
    try {
      const response = await api.get(SUPPORT_TICKETS_LIST_URL, {
        params: filters,
      });
      
      console.log("🔍 Resposta da API de tickets:", response.data);
      
      // Verificar diferentes formatos de resposta da API
      if (Array.isArray(response.data)) {
        // Formato: [{ status: "Aberto", results: [...] }]
        const allTickets = [];
        response.data.forEach(statusGroup => {
          if (statusGroup && statusGroup.results && Array.isArray(statusGroup.results)) {
            allTickets.push(...statusGroup.results);
          }
        });
        
        console.log("✅ Tickets processados do array:", allTickets.length, "tickets");
        return {
          success: true,
          data: allTickets,
        };
      } else if (response.data && typeof response.data === 'object' && 'results' in response.data) {
        // Formato padrão paginado: { results: [...] }
        console.log("✅ Tickets do formato paginado:", response.data.results?.length || 0, "tickets");
        return {
          success: true,
          data: response.data.results || [],
        };
      }
      
      // Formato direto: [...]
      console.log("✅ Tickets do formato direto:", response.data?.length || 0, "tickets");
      return {
        success: true,
        data: Array.isArray(response.data) ? response.data : [],
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte não está disponível",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao buscar tickets",
      };
    }
  },

  createTicket: async (ticketData) => {
    try {
      const formData = new FormData();
      
      formData.append("title", ticketData.title);
      formData.append("description", ticketData.description);
      formData.append("category", ticketData.category);
      formData.append("priority", ticketData.priority);
      
      if (ticketData.attachments) {
        formData.append("attachments", ticketData.attachments);
      }
      
      const response = await api.post(SUPPORT_TICKETS_CREATE_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao criar ticket",
      };
    }
  },

  updateTicket: async (ticketId, updateData) => {
    try {
      const response = await api.put(SUPPORT_TICKETS_UPDATE_URL(ticketId), updateData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao atualizar ticket",
      };
    }
  },

  assignTicket: async (ticketId, agentId) => {
    try {
      const response = await api.post(SUPPORT_TICKETS_ASSIGN_URL(ticketId), {
        agent_id: agentId,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao atribuir ticket",
      };
    }
  },

  // ===============================================
  // SISTEMA DE CHAT
  // ===============================================

  getChats: async (filters = {}) => {
    try {
      const response = await api.get(SUPPORT_CHATS_LIST_URL, {
        params: filters,
      });
      
      // Verificar se a resposta tem formato paginado
      if (response.data && typeof response.data === 'object' && 'results' in response.data) {
        return {
          success: true,
          data: response.data.results,
        };
      }
      
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao buscar chats",
      };
    }
  },

  createChat: async (chatData) => {
    try {
      const response = await api.post(SUPPORT_CHATS_CREATE_URL, chatData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao criar chat",
      };
    }
  },

  assignChat: async (chatId, agentId) => {
    try {
      const response = await api.post(SUPPORT_CHATS_ASSIGN_URL(chatId), {
        agent_id: agentId,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao atribuir chat",
      };
    }
  },

  closeChat: async (chatId, closeData = {}) => {
    try {
      const response = await api.post(SUPPORT_CHATS_CLOSE_URL(chatId), closeData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao finalizar chat",
      };
    }
  },

  getChatMessages: async (chatId) => {
    try {
      const response = await api.get(SUPPORT_CHATS_MESSAGES_URL(chatId));
      
      // Verificar se a resposta tem formato paginado
      if (response.data && typeof response.data === 'object' && 'results' in response.data) {
        return {
          success: true,
          data: response.data.results,
        };
      }
      
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao buscar mensagens",
      };
    }
  },

  sendChatMessage: async (chatId, messageData) => {
    try {
      const response = await api.post(SUPPORT_CHATS_MESSAGES_URL(chatId), messageData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao enviar mensagem",
      };
    }
  },

  // ===============================================
  // WEBSOCKET CHAT
  // ===============================================

  createChatWebSocket: (roomId, token, callbacks = {}) => {
    try {
      const socketUrl = `${WEBSOCKET_URL}support/chat/${roomId}/?token=${token}`;
      const socket = new WebSocket(socketUrl);

      socket.onopen = (event) => {
        console.log("WebSocket conectado ao chat:", roomId);
        if (callbacks.onOpen) callbacks.onOpen(event);
      };

      socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (callbacks.onMessage) callbacks.onMessage(data);
        } catch (error) {
          console.error("Erro ao processar mensagem WebSocket:", error);
        }
      };

      socket.onclose = (event) => {
        console.log("WebSocket desconectado do chat:", roomId);
        if (callbacks.onClose) callbacks.onClose(event);
      };

      socket.onerror = (error) => {
        console.error("Erro no WebSocket do chat:", error);
        if (callbacks.onError) callbacks.onError(error);
      };

      return socket;
    } catch (error) {
      console.error("Erro ao criar WebSocket do chat:", error);
      if (callbacks.onError) callbacks.onError(error);
      return null;
    }
  },

  sendWebSocketMessage: (socket, type, payload) => {
    if (!socket || socket.readyState !== WebSocket.OPEN) {
      console.warn("WebSocket n�o est� conectado");
      return false;
    }

    try {
      const message = {
        type: type,
        ...payload,
      };
      socket.send(JSON.stringify(message));
      return true;
    } catch (error) {
      console.error("Erro ao enviar mensagem WebSocket:", error);
      return false;
    }
  },

  // ===============================================
  // GERENCIAMENTO DE AGENTES
  // ===============================================

  getAgents: async () => {
    try {
      const response = await api.get(SUPPORT_AGENTS_LIST_URL);
      
      // Verificar se a resposta tem formato paginado
      if (response.data && typeof response.data === 'object' && 'results' in response.data) {
        return {
          success: true,
          data: response.data.results,
        };
      }
      
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao buscar agentes",
      };
    }
  },

  createAgent: async (agentData) => {
    try {
      const response = await api.post(SUPPORT_AGENTS_CREATE_URL, agentData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao criar agente",
      };
    }
  },

  updateAgent: async (agentId, agentData) => {
    try {
      const response = await api.put(SUPPORT_AGENTS_UPDATE_URL(agentId), agentData);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao atualizar agente",
      };
    }
  },

  updateAgentStatus: async (agentId, status) => {
    try {
      const response = await api.post(SUPPORT_AGENTS_UPDATE_STATUS_URL(agentId), {
        status: status,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao atualizar status do agente",
      };
    }
  },

  getAvailableAgents: async () => {
    try {
      const response = await api.get(SUPPORT_AGENTS_AVAILABLE_URL);
      
      // Verificar se a resposta tem formato paginado
      if (response.data && typeof response.data === 'object' && 'results' in response.data) {
        return {
          success: true,
          data: response.data.results,
        };
      }
      
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      if (!error.response) {
        return {
          success: false,
          isApiUnavailable: true,
          error: "API de suporte n�o est� dispon�vel",
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao buscar agentes dispon�veis",
      };
    }
  },

  // ===============================================
  // WEBSOCKET NOTIFICA��ES (APENAS AGENTES)
  // ===============================================

  createSupportNotificationsWebSocket: (token, callbacks = {}) => {
    try {
      const socketUrl = `${WEBSOCKET_URL}support/notifications/?token=${token}`;
      const socket = new WebSocket(socketUrl);

      socket.onopen = (event) => {
        console.log("WebSocket de notifica��es de suporte conectado");
        if (callbacks.onOpen) callbacks.onOpen(event);
      };

      socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (callbacks.onMessage) callbacks.onMessage(data);
        } catch (error) {
          console.error("Erro ao processar notifica��o WebSocket:", error);
        }
      };

      socket.onclose = (event) => {
        console.log("WebSocket de notifica��es de suporte desconectado");
        if (callbacks.onClose) callbacks.onClose(event);
      };

      socket.onerror = (error) => {
        console.error("Erro no WebSocket de notifica��es:", error);
        if (callbacks.onError) callbacks.onError(error);
      };

      return socket;
    } catch (error) {
      console.error("Erro ao criar WebSocket de notifica��es:", error);
      if (callbacks.onError) callbacks.onError(error);
      return null;
    }
  },
};

// Exportar m�todos individuais para compatibilidade
export const getSupportConfig = SupportService.getSupportConfig;
export const createSupportConfig = SupportService.createSupportConfig;
export const updateSupportConfig = SupportService.updateSupportConfig;

export const getTickets = SupportService.getTickets;
export const createTicket = SupportService.createTicket;
export const updateTicket = SupportService.updateTicket;
export const assignTicket = SupportService.assignTicket;

export const getChats = SupportService.getChats;
export const createChat = SupportService.createChat;
export const assignChat = SupportService.assignChat;
export const closeChat = SupportService.closeChat;
export const getChatMessages = SupportService.getChatMessages;
export const sendChatMessage = SupportService.sendChatMessage;

export const createChatWebSocket = SupportService.createChatWebSocket;
export const sendWebSocketMessage = SupportService.sendWebSocketMessage;

export const getAgents = SupportService.getAgents;
export const createAgent = SupportService.createAgent;
export const updateAgent = SupportService.updateAgent;
export const updateAgentStatus = SupportService.updateAgentStatus;
export const getAvailableAgents = SupportService.getAvailableAgents;

export const createSupportNotificationsWebSocket = SupportService.createSupportNotificationsWebSocket;

export default SupportService;